import { render } from "./order-shipping.vue?vue&type=template&id=b26b5c66&scoped=true"
import script from "./order-shipping.vue?vue&type=script&lang=js"
export * from "./order-shipping.vue?vue&type=script&lang=js"

import "./order-shipping.vue?vue&type=style&index=0&id=b26b5c66&lang=css"
import "./order-shipping.vue?vue&type=style&index=1&id=b26b5c66&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26b5c66"]])

export default __exports__